import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import LottyLoading from '../LottyLoading';

interface ILogoLoadingProps {
  size?: 'small' | 'medium' | 'large';
  background?: string;
}

const slide = keyframes`
	0% {transform:translateX(-100%);}
	100% {transform:translateX(200%);}
`;

const animationRule = css`
  ${slide} 1s infinite;
`;

const setSize = {
  small: '90px',
  medium: '100px',
  large: '120px',
};

const Container = styled('div')<ILogoLoadingProps>`
  margin: auto;
  height: 300px;
  position: relative;
  width: ${(props) => (props.size ? setSize[props.size] : '300px')};
  opacity: 0.7;
  // &:after {
  //   content: '';
  //   top: 0;
  //   transform: translateX(100%);
  //   width: 100%;
  //   height: ${(props) => (props.size ? setSize[props.size] : '100px')};
  //   position: absolute;
  //   z-index: 1;
  //   animation: ${animationRule};
  //   background: linear-gradient(
  //     to right,
  //     rgba(255, 255, 255, 0) 0%,
  //     ${(props) => props.background || 'rgba(255, 255, 255, 0.8)'} 50%,
  //     rgba(255, 255, 255, 0.5) 99%,
  //     rgba(255, 255, 255, 0.5) 100%
  //   );
  // }
  & > svg {
    width: ${(props) => (props.size ? setSize[props.size] : '100px')};
    height: ${(props) => (props.size ? setSize[props.size] : '100px')};
  }
`;

const LogoLoading: React.FC<ILogoLoadingProps> = ({ size, background }) => {
  return (
    <Container size={size} background={background}>
      <LottyLoading src={'/assets/loading.json'} />
    </Container>
  );
};

export default React.memo(LogoLoading);
